module.exports = __webpack_public_path__ + "img/crm_no_demand.edbc3019.png";